import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';
import PdfSNPService from '@/shared/services/snp/pdf.service';
import AlertService from '@/shared/alert/alert.service';
import VisualizadorPdfComponent from '@/components/visualizador-pdf/visualizador-pdf.vue';
import EvaluacionSnpService from '@/shared/services/snp/EvaluacionSnpService';
import { encrypt } from '@/shared/util/cifrado';
import { DocumentoGenericoDTO } from '@/shared/model/documento-generico';
import VerPdfUrl from '@/entities/snp/snippets/verPdfUrl/ver-pdf-url.vue';
import { EstadoInsaculacion } from '@conacyt/insaculacion-client';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';

@Component({
  components: {
    'visualizador-pdf': VisualizadorPdfComponent,
    'ver-pdf-url': VerPdfUrl,
  },
})
export default class FirmarDictamenSnpComponent extends Vue {
  @Inject('pdfSNPService') private readonly pdfSNPService: () => PdfSNPService;
  @Inject('alertService') private readonly alertService: () => AlertService;
  @Inject('evaluacionSnpService') private readonly evaluacionSnpService: () => EvaluacionSnpService;

  @Prop({ required: true })
  public readonly revisionId!: string;

  @Prop({ required: false, default: undefined })
  public readonly urlDictamen!: string;

  @Prop({ required: true, default: false })
  public permitirFirmar!: boolean;

  @Prop({ required: true })
  public estadoInsaculacion!: EstadoInsaculacion;

  @Prop({ required: true })
  public estadoRevision!: EstadoRevision;

  public mostrarModalClave = false;
  public clave = '';
  public tipoCampoClave = 'password';

  public mostrarPdf = false;
  public consultando = false;
  public contenidoBase64 = '';

  public previsualizarDictamen(): void {
    this.mostrarPdf = false;
    this.consultando = true;

    this.pdfSNPService()
      .exportarDictamenEvaluacionPosgradoPdf(this.revisionId)
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  public verModalClave(): void {
    if (this.permitirFirmar) {
      this.mostrarModalClave = true;
    }
  }

  public firmarDictamen(): void {
    if (EstadoInsaculacion.Aprobada != this.estadoInsaculacion || EstadoRevision.REVISADA != this.estadoRevision) {
      return;
    }
    this.mostrarPdf = false;
    this.consultando = true;
    this.mostrarModalClave = false;

    if (!this.permitirFirmar) {
      return;
    }

    let claveCifrada = '';
    try {
      claveCifrada = encrypt(this.clave, this.revisionId + 'GerR45W#');
      this.evaluacionSnpService()
        .firmarDictamenPdf(this.revisionId, claveCifrada)
        .then(responseDocumento => {
          this.emitirCambios(responseDocumento);
          this.alertService().showSuccess(this, this.$t('apeironGwApp.dictamenSnp.mensajes.dictamenFirmado').toString());
        })
        .catch(error => {
          this.mostrarPdf = false;
          this.alertService().showHttpError(this, error.response);
        })
        .finally(() => {
          this.clave = '';
          this.consultando = false;
        });
    } catch (error) {
      this.consultando = false;
      this.clave = '';
      this.alertService().showError(this, this.$t('apeironGwApp.dictamenSnp.mensajes.ocurrioUnError').toString());
    }
  }

  @Emit('change')
  public emitirCambios(documento: DocumentoGenericoDTO): DocumentoGenericoDTO {
    return documento;
  }
}
